import { Controller } from "@hotwired/stimulus";

/**
 * `history.back()` で戻るやつ
 * link_to :back で戻ると通常の画面遷移になってしまってスクロール位置が先頭に戻ってしまう対策
 * 階層が深い 1→2→3 などの場合、3→2 の遷移があると 2→3 で戻ってしまうので注意
 * 3 にもこれを仕込んでおけば 3→2→1 で戻れる
 *
 * ### 使い方の基本
 *   - Default: <%= link_back_or_to root_path, class: "..." %>
 *   - StoreStaff: <%= link_back_or_to store_staff_root_path, class: "..." %>
 *   - Admin: <%= link_back_or_to admin_root_path, class: "..." %>
 *
 * ただし、data-controller の追加は link_back_or_to が同一サイト内の場合自動で追加してくれる
 * 自分で data-controller="history-back" を追加してもよい
 */
export default class extends Controller {
  connect() {
    // ページ遷移した場合は timeout を止める。
    this.timeoutID = null;

    window.addEventListener("beforeunload", this.#onbeforeunload);
    // pushState で URL が変わった後で、ページバックなどした場合。
    window.addEventListener("popstate", this.#onpopstate);
    // history back で hash だけが変わる場合もある。
    window.addEventListener("hashchange", this.#onhashchange);
    this.element.addEventListener("click", this.#onclick);
  }

  disconnect() {
    this.#clearTimeout();

    window.removeEventListener("beforeunload", this.#onbeforeunload);
    window.removeEventListener("popstate", this.#onpopstate);
    window.removeEventListener("hashchange", this.#onhashchange);
    this.element.removeEventListener("click", this.#onclick);
  }

  #onbeforeunload = () => {
    // 止めなくてもページ遷移でキャンセルされてるっぽいけど、念の為。
    this.#clearTimeout();
  };

  #onclick = (ev) => {
    ev.preventDefault();
    history.back();
    // すぐにページ遷移しなかったら、history.back で戻れるページが存在しないと見なす。
    // https://www.softel.co.jp/blogs/tech/archives/4322
    // 一応 disconnect でも止めているけど、次に表示されるページ次第では間に合わない。
    // フルロードの場合は、すぐに beforeunload が呼ばれるので 100ms で十分。
    // pushState で遷移した後にページリロードしてからバックした場合には 100ms では間に合わなかった。400ms くらい必要。
    // この場合は popstate で拾えるはず。
    this.timeoutID = setTimeout(() => {
      location.href = this.element.href;
    }, 100);
  };

  #clearTimeout() {
    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
      this.timeoutID = undefined;
    }
  }

  #onpopstate = () => {
    this.#clearTimeout();
  };

  #onhashchange = () => {
    this.#clearTimeout();
  };
}
